import style from "./style.module.sass";
import {ReactNode} from "react";


export const SimpleGreyBackgroundContainer = (props: { children: ReactNode }) => {
    return   <div className={style.container}>
        {props.children}
    </div>
};